<template lang="html">
  <div class="ft-markup-editor">
    <v-text-field
      v-if="label"
      :label="label"
      hide-details
      :rules="rules"
      :value="value || '--'"
      class="ft-hide-input pt-0 pb-4"
    />
    <vue-editor
      v-model="htmlValue"
      style="background-color: #FFF; color: #000"
      :editor-toolbar="settingEditorToolbar"
      :disabled="disabled"
    />
    <!-- Error/hint display for HTML value -->
    <v-text-field
      v-if="hint || errorMessages"
      :value="value"
      :rules="rules"
      class="ft-hide-input pt-0"
      :error-messages="errorMessages"
      :hint="hint"
      :persistent-hint="persistentHint"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import {Quill, VueEditor} from 'vue2-editor'

const Parchment = Quill.import('parchment')
const BlockEmbed = Quill.import('blots/block/embed')

Quill.register(Quill.import('attributors/style/direction'), true)
Quill.register(Quill.import('attributors/style/align'), true)
Quill.register(Quill.import('attributors/style/font'), true)
// Quill.register(Quill.import('attributors/style/size'), true)
// Quill.register(Quill.import('attributors/style/font'), true)

class ImageBlot extends BlockEmbed {
  static create (value) {
    let node = super.create()
    node.setAttribute('src', value)
    node.setAttribute('style', 'max-width: 100%')
    return node
  }

  static value (node) {
    return {
      alt: node.getAttribute('alt'),
      url: node.getAttribute('src'),
      style: node.getAttribute('style')
    }
  }
}
ImageBlot.blotName = 'image'
ImageBlot.tagName = 'img'

Quill.register(ImageBlot)

const fontSizeStyle = Quill.import('attributors/style/size')
const fontSizes = ['small', false, 'large', 'x-large']
fontSizeStyle.whitelist = fontSizes
Quill.register(fontSizeStyle, true)

class IndentAttributor extends Parchment.Attributor.Style {
  add (node, value) {
    if (value === 0) {
      this.remove(node)
      return true
    } else {
      return super.add(node, `${value}em`)
    }
  }
}

let IndentStyle = new IndentAttributor('indent', 'text-indent', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em']
})

Quill.register(IndentStyle, true)

export default {
  name: 'HtmlEditor',
  components: {
    VueEditor
  },
  mixins: [],
  props: {
    label: String,
    persistentHint: Boolean,
    hint: String,
    value: String,
    errorMessages: Array,
    disabled: Boolean,
    rules: Array
  },
  data: function () {
    return {
      htmlValue: null,
      lastDebounce: null,
      settingEditorToolbar: [
        // [{ font: [] }], // No inline style generator yet
        [{header: [false, 1, 2, 3, 4, 5, 6]}],
        [{size: fontSizes}],
        ['bold', 'italic', 'underline', 'strike'],
        [
          {align: ''},
          {align: 'center'},
          {align: 'right'},
          {align: 'justify'}
        ],
        // [{ header: 1 }, { header: 2 }],
        // ['blockquote', 'code-block'],
        // ['blockquote'],
        // [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], // No inline style generator yet
        [{script: 'sub'}, {script: 'super'}],
        [{indent: '-1'}, {indent: '+1'}],
        [{color: []}, {background: []}],
        ['link', 'image', 'video'],
        [{direction: 'rtl'}],
        ['clean']
      ]
    }
  },
  computed: {
  },
  watch: {
    htmlValue () {
      clearTimeout(this.lastDebounce)
      if (this.value !== this.htmlValue) {
        // Only emit changes after no typing for 500ms
        this.lastDebounce = setTimeout(() => {
          this.$emit('input', this.htmlValue)
        }, 500)
      }
    },
    value () {
      if (this.htmlValue !== this.value) {
        this.htmlValue = this.value
      }
    }
  },
  mounted () {
    this.htmlValue = this.value
  },
  methods: {
  }
}
</script>
<style>
  .ft-markup-editor .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="x-large"]::before,
  .ft-markup-editor .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="x-large"]::before {
    content: 'X-Large';
    font-size: 20px;
  }
  .ft-editor-form-tabs > .tabs__items {
    overflow: visible;
  }
  .ft-editor-form-tabs > .tabs__items .ql-tooltip {
    z-index: 90000;
  }

</style>
